export const ATTRS = {
	mapHolder: '[map-holder]',
	filterForm: '[filter-form]',
	checkboxGroup: '[check-box-group]',
	cmsList: '[cms-map-list]',
	pin: '[map-pin]',
	content: '[map-content]',
	filterGroup: '[filter-group]',
	filterLabel: '[filter-label]',
	checkboxField: '[checkbox-field]',
};
